<div class="overlay" *ngIf="loader.isLoading$ | async">
  <mat-spinner class="spinner"></mat-spinner>
</div>
